export const PORTFOLIO_ACCESS_RIGHTS_REQUEST = 'PORTFOLIO_ACCESS_RIGHTS_REQUEST'

export const PORTFOLIO_GET_GROUP_INFO_REQUEST = (groupId) => `PORTFOLIO_GET_${groupId}_GROUP_INFO_REQUEST`
export const PORTFOLIO_GET_TOKEN_REQUEST = (groupId) => `PORTFOLIO_GET_${groupId}_TOKEN_REQUEST`
export const PORTFOLIO_GROUP_UPDATE = (groupId) => `PORTFOLIO_GROUP_${groupId}_UPDATE`
export const PORTFOLIO_GROUP_DELETE_UPDATE = (groupId) => `PORTFOLIO_GROUP_${groupId}_DELETE_UPDATE`

export const OPEN_PORTFOLIO_BY_ID = 'OPEN_PORTFOLIO_BY_ID'
export const CLOSE_PORTFOLIO_BY_ID = 'CLOSE_PORTFOLIO_BY_ID'
export const REFRESH_PORTFOLIO_BY_ID = 'REFRESH_PORTFOLIO_BY_ID'

export const LOAD_PORTFOLIO_MODULE_ACCESS_RIGHTS = 'LOAD_PORTFOLIO_MODULE_ACCESS_RIGHTS'
export const SET_PORTFOLIO_MODULE_ACCESS_RIGHTS = 'SET_PORTFOLIO_MODULE_ACCESS_RIGHTS'

export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Portfolio'
export const PORTFOLIO_LOADER_ID = 'portfolioLoader'
export const PORTFOLIO_GROUP_LOADER_ID = 'portfolioGroupLoader'

export const DELETED_GROUP_MEMBER_COUNT = -1
